import styled from "styled-components";

export const StyledReportIssuePage = styled.div``;

export const LabelText = styled.span`
//   position: absolute;
  float: left;
  padding: 5px;
`